import React from "react";
import { useTranslation } from "next-i18next";

/**
 * DisclaimerSection: Shared disclaimer for all downloader pages.
 * Uses i18n for content.
 */
const DisclaimerSection: React.FC = () => {
  const { t } = useTranslation("about");

  return (
    <section className="py-16 px-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700 mt-8">
      <div className="container mx-auto max-w-4xl">
        <h3 className="text-lg font-medium mb-4 text-gray-900 dark:text-white">
          {t("disclaimer.title", "Disclaimer")}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          {t("disclaimer.desc1", "All company names or logos are ® trademarks of their respective holders. Any digital content you choose to download with this tool will be provided directly from their CDN respective servers and will not be stored by us.")}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-300 mt-2" dangerouslySetInnerHTML={{
          __html: t("disclaimer.desc2", "<strong>User privacy, User data, with GDPR and CCPA:</strong> We comply with GDPR and CCPA, ensuring no storage of IP addresses or personal data. Our cookies enhance user-friendliness without tracking your information. Your privacy is our priority.")
        }} />
      </div>
    </section>
  );
};

export default DisclaimerSection;
